// ── Compound Illumination params ──
// The Viewer's pearl-warm light accumulates per-cell in the field's dot grid.
// Forward narrative lights cells; backscroll never extinguishes them.
//
// All values here are intentionally adjustable for AR/MB iteration without
// touching renderer code. Save → HMR → see the difference.

export const ILLUMINATION = {
  // Pearl-warm — the Viewer's neutral-bright colour.
  // Reuses --text (#f5efe0). Distinct from SB orange.
  baseColor: { r: 245, g: 239, b: 224 },

  // Per-cell brightness range. Most cells stay near min; rare cells reach max.
  brightnessMin: 0.06,
  brightnessMax: 0.85,

  // Power-distribution bias. Higher = more cells dim.
  // brightness = lerp(min, max, pow(rand01, darkBias))
  darkBias: 3.0,

  // How much fieldStoryTime (0..1) it takes to span the full grid lighting.
  // 1.0 means: full scroll = full illumination potential.
  illuminationSpan: 1.0,

  // Threshold distribution bias. threshold = hash01^thresholdBias * illuminationSpan.
  // bias > 1 biases thresholds toward 0 (more cells light early — needed for B2:
  // ≥5% of cells > 0.15 by glassProgress = 0.08). bias = 1 gives uniform.
  thresholdBias: 1.5,

  // Soft band around each cell's threshold for the smoothstep reveal.
  // Larger = softer fade-in across more of fieldStoryTime; smaller = sharper.
  revealWidth: 0.05,

  // Faint substrate dot for unlit cells — visible structure of the field.
  unlitAlpha: 0.10,
  unlitDotRadius: 1.4,

  // Lit cell visual size (square — the "bit" form).
  litCellSize: 5,

  // Grid density (cells across × down). Independent of viewport pixel size.
  cols: 28,
  rows: 16,

  // Mobile breakpoint grid (viewport < 600px wide). Reseeds threshold/brightness deterministic.
  colsMobile: 18,
  rowsMobile: 12,

  // Grid spans this fraction of viewport (centred). Glass blurs the edges out.
  spanX: 0.92,
  spanY: 0.84,

  // Reduced-motion cap. Multiplies all alpha output so the static
  // destination-state snapshot stays quiet under text.
  reducedMotionAlphaCap: 0.55,

  // ── Viewer (Phase 2B, internal-name Anemone) ───────────────────
  // The presence that emerges in the field at About (Beat 4) and
  // dissolves by Articles (Beat 8). Filaments, not creature.
  viewerTentacleCount: 8,
  viewerTentacleLength: 100,    // px at full extension (rest)
  viewerStrokeWidth: 2.4,        // line width per tentacle
  viewerAnchorGlow: 36,          // px radius for the central radial glow

  // ── Persistent residue (Phase 2C) ──────────────────────────────
  // On return visit, a fraction of previously-lit cells get pre-lit at low
  // alpha so the user sees "memory of last time" before re-lighting it.
  // Avoids brand-thesis contradiction (full reset) AND origin-skip (full replay).
  residueFraction: 0.35,         // 35% of previously-lit cells get ghost-light
  residueAlpha: 0.10,            // ghost cellLight value for seeded cells
};
